<template>
  <div class="home">
    <div class="wrapper">
      <top-view></top-view>
      <div class="separator-title">
        <h3>기술</h3>
      </div>
      <div class="skill-container">
        <div class="skill-column">
          <span
            class="skill-bar"
            v-for="skill in skills"
            :key="skill"> 
            {{skill}}
          </span>
        </div>
      </div>
      <div class="projects">
        <cool-light-box
          v-for="(app) in appCards['2022']"
          :key="app.name"
          :items="app.videoList"
          :index="lightBoxIndex[app.name]"
          :effect="'fade'"
          @close="lightBoxIndex[app.name] = null">
        </cool-light-box>
        <cool-light-box
          v-for="(app) in appCards['2019']"
          :key="app.name"
          :items="app.videoList"
          :index="lightBoxIndex[app.name]"
          :effect="'fade'"
          @close="lightBoxIndex[app.name] = null">
        </cool-light-box>
        <cool-light-box
          :items="webProjects.map((el,i)=>el.src)" 
          :index="lightBoxIndex['web']"
          :effect="'fade'"
          @close="lightBoxIndex['web'] = null">
        </cool-light-box>
        <div class="separator-title">
          <h3>2022~</h3>
          <a>
            <v-icon name="user" scale="1.0" color="#2f2f2f"></v-icon>
            <span>개인 프로젝트</span>
          </a>
        </div>
        <div class="doc">
          <app-card
            v-for="(app) in appCards['2022']"
            :key="app.name"
            :name="app.name" 
            :explain="app.explain" 
            :googlePlay="app.googlePlay ? app.googlePlay : ''"
            :appStore="app.appStore ? app.appStore : ''"
            :src="app.src"
            @clickAppIcon="clickAppIcon(app.name, 0)">
          </app-card>
        </div>
        <div class="separator-title">
          <h3>2019~</h3>
          <a>
            <v-icon name="user" scale="1.0" color="#2f2f2f"></v-icon>
            <span>개인 프로젝트</span>
          </a>
        </div>
        <div class="main-doc">
          <app-card
            v-for="(app) in appCards['2019']"
            :key="app.name"
            :name="app.name" 
            :explain="app.explain" 
            :googlePlay="app.googlePlay ? app.googlePlay : ''"
            :appStore="app.appStore ? app.appStore : ''"
            :src="app.src"
            @clickAppIcon="clickAppIcon(app.name, 0)">
          </app-card>
        </div>
        <div class="separator-title">
          <h3>2017.09 ~ 2019.08</h3>
          <a>
            <v-icon name="user-friends" scale="1.4" color="#2f2f2f"></v-icon>
            <span>공군 기상단 체계 개발실</span>
          </a>
        </div>
        <div class="carousel-inner">
          <carousel-3d
            :display="3" :controls-visible="true"
            :controls-prev-html="'&#10092;'" :controls-next-html="'&#10093;'">
            <slide
              v-for="(web, i) in webProjects"
              :key="web.name"
              :index="i">
              <web
                :name="web.name" 
                :src="web.src"
                @clickWeb="clickWeb('web', i)">
              </web>
            </slide>
          </carousel-3d>
        </div>
        <div class="separator-title">
          <h3>2015.03 ~ 2017.01</h3>
          <a>
            <v-icon name="user-friends" scale="1.4" color="#2f2f2f"></v-icon>
            <span>터치터치</span>
          </a>
        </div>
        <div class="doc">
          <app-icon
            v-for="(app) in appIcons"
            :key="app.name"
            :name="app.name" 
            :src="app.src"
            :name-display="true">
          </app-icon>
        </div>
        <div class="separator-title">
          <h3>2014.08</h3>
          <a>
            <v-icon name="user" scale="1.0" color="#2f2f2f"></v-icon>
            <span>개인 프로젝트</span>
          </a>
        </div>
        <app-card
          class="circle-wrapper"
          name="in the cube"
          src="app_icons/student/inthecube.png"
          windows="https://dabin.playgm.co.kr/attachment/cfile1.uf@2639064E53E8A867015782.exe">
        </app-card>
      </div>
    </div>
    <footer>
      <a class="url-bar" href="https://mynameisdabin.tistory.com/" target="_blank">
        <v-icon name="link" scale="1.2"/>
        <div>티스토리 블로그</div>
      </a>
      <a class="url-bar" href="https://github.com/MyNameIsDabin" target="_blank">
        <v-icon name="brands/github" scale="1.4"/>
        <div>깃 허브</div>
      </a>
      <a class="url-bar" href="mailto:dorothy9795@gmail.com" target="_blank">
        <v-icon name="envelope" scale="1.4"/>
        <div>dorothy9795@gmail.com</div>
      </a>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import TopView from '@/components/TopView.vue'
import AppIcon from '@/components/AppIcon.vue'
import AppCard from '@/components/AppCard.vue'
import Web from '@/components/Web.vue'

export default {
  name: 'Home',
  data: () => {
    return {
      skills: ["C#", "Unity3D", "C++", "Cocos2d-x", "Godot", "JavaScript", "JAVA", "Node.js", "Vue.js", "D3.js"],
      webSliderTouchIndex: 0,
      lightBoxIndex: {
        "web": null
      },
      appCards: {
        "2022": [{
          name: "얼렁뚱땅 서바이벌",
          explain: "이러쿵 저러쿵",
          src: "app_icons/davinscode/sillysurvival.png",
          googlePlay: "https://play.google.com/store/apps/details?id=com.davin.sillysurvival",
          appStore: "https://apps.apple.com/kr/app/%EC%96%BC%EB%A0%81%EB%9A%B1%EB%95%85-%EC%84%9C%EB%B0%94%EC%9D%B4%EB%B2%8C/id1631721746",
          videoList: [
            "https://www.youtube.com/watch?v=cWoNiiPM_JQ",
          ]
        }],
        "2019": [{
          name: "랜덤 모아이 디펜스",
          explain: "이러쿵 저러쿵",
          src: "app_icons/davinscode/moai.png",
          googlePlay: "https://play.google.com/store/apps/details?id=com.davin.moai",
          appStore: "https://apps.apple.com/kr/app/%EB%9E%9C%EB%8D%A4-%EB%AA%A8%EC%95%84%EC%9D%B4-%EB%94%94%ED%8E%9C%EC%8A%A4/id1495531699",
          videoList: [
            "https://www.youtube.com/watch?v=q3b8jbY0Xgg&t=1s",
            "https://www.youtube.com/watch?v=BC84Zr43Hg4&t=266s"
          ]
        },{
          name: "GONG",
          explain: "이러쿵 저러쿵",
          src: "app_icons/davinscode/gong.png",
          googlePlay: "https://play.google.com/store/apps/details?id=com.davin.gong",
          videoList: [
            "https://www.youtube.com/watch?v=tlQveyh517I"
          ]
        }]
      },
      webProjects: [{
        name: "태풍조회서비스",
        src: "web_image/typhoon.jpg"
      },{
        name: "웹기상정보지원체계",
        src: "web_image/weather0.jpg"
      },{
        name: "낙뢰발생통보체계",
        src: "web_image/thunder.jpg"
      }],
      appIcons: [{
        name: "서바이벌 빙고",
        src: "app_icons/touchtouch/bingo.png",
      },{
        name: "보이스 피싱",
        src: "app_icons/touchtouch/boysfishing.png",
      },{
        name: "Hero’s gone",
        src: "app_icons/touchtouch/heroisgone.png",
      },{
        name: "직장상사 혼내주기",
        src: "app_icons/touchtouch/hitboss.png",
      },{
        name: "SlitherCoin",
        src: "app_icons/touchtouch/slithercoin.png",
      }],
    }
  },
  methods: {
    clickWeb(key, index) {
      if (this.webSliderTouchIndex == index) {
        this.lightBoxIndex[key] = index 
      }
      this.webSliderTouchIndex = index
    },
    clickAppIcon(appName, index) {
      this.lightBoxIndex[appName] = index 
    },
    initLightBoxes() {
      Object.keys(this.appCards).forEach(key => this.appCards[key].forEach(el => this.$set(this.lightBoxIndex, el.name, null)))
    }
  },
  created() {
    this.initLightBoxes()
  },
  mounted() {
  },
  components: {
    TopView,
    AppIcon,
    AppCard,
    Web
  }
}
</script>

<style scoped>
footer {
  margin: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.url-bar {
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 1.1rem;
  color: #2f2f2f;
  text-decoration: none;
}
.url-bar:hover {
  color: #3f51b5;
  text-decoration: underline;
}
.url-bar div {
  margin-left: 5px;
}
.skill-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.skill-column {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px;
}
.main-doc {
  display: flex;
}
.doc {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 5px;
}
.wrapper {
  max-width: 850px;
}
.wrapper h3 {
  margin: 25px 18px;
  border-left: 2px solid #ec6a96;
  padding-left: 10px;
}
.skill-bar {
  font-size: 1.1rem;
  margin: 2px;
  padding: 2px 4px;
  background-color: #2f2f2f;
  border-radius: 2px;
  color: white;
}
.separator-title, .separator-title a {
  display: flex;
  align-items: center;
}
.separator-title a {
  border-radius: 6px;
}
.separator-title h3 {
  flex-grow: 1;
}
.separator-title span {
  margin: 5px;
  /* font-weight: bold; */
  font-size: 0.9rem;
}
</style>

<style>
.projects div.carousel-3d-container {
  margin-bottom: 0;
}
.projects div.carousel-3d-slide {
  background: none;
  border: 0;
  width: 100%;
  height: auto;
}
.circle-wrapper img.app-image {
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
}
@media screen and (max-width: 350px) {
  .separator-title > h3, footer .url-bar div {
    font-size: 0.8rem;
  }
  .separator-title .fa-icon, footer .fa-icon {
    width: 15px;
  }
}
@media screen and (max-width: 720px) {
  .main-doc {
    flex-direction: column;
  }
  .main-doc .app-container {
    flex-shrink: 1;
  }
  .doc .app-image {
    flex-direction: column;
    width: 80px;
    height: 80px;
  }
  .doc .app-name {
    font-size: 0.8rem;
  }
}
</style>